import React from 'react';
import PropTypes from 'prop-types';
import PeriodTabsListing from '../PeriodTabs/PeriodTabsListing';
import FlexPublicationCard from './FlexPublicationCard';
import publicationYearSpec, { asPeriodTabsSettings } from './publicationYears';

/**
 * Publications with a bar of years built from the block's own query.
 *
 * The first of the period-tabs listings, and now one of them: the years come
 * from counting how many results this query has in each candidate year, and
 * with `year_pages_base` set the tabs link to `/publications/<year>`. See
 * `PeriodTabsListing` for how the bar works and `publicationYears.js` for
 * what is particular to publications.
 */
const PublicationYearTabsListingView = (props) => (
  <PeriodTabsListing
    {...asPeriodTabsSettings(props)}
    spec={publicationYearSpec}
    card={FlexPublicationCard}
    cardProps={{
      showAuthorLinks: props.show_author_links !== false,
      compact: props.compact,
      hideLink: props.hide_link,
    }}
  />
);

PublicationYearTabsListingView.propTypes = {
  show_author_links: PropTypes.bool,
  year_tabs_count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  year_pages_base: PropTypes.string,
  older_link_label: PropTypes.string,
  older_link_url: PropTypes.string,
  compact: PropTypes.bool,
  hide_link: PropTypes.bool,
};

export default PublicationYearTabsListingView;
